import BulkCreateCategorySelect from "./bulkCreateCategorySelect.container";

export default BulkCreateCategorySelect